import React from 'react'
import { Modal } from 'antd'
import PlayerInterfacePopup from '../PlayerInterfacePopup'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal } from '../../redux/actions/interfaceModalActions'

const PlayerDetailsModal = () => {
  const INTERFACE = useSelector((state) => state.interfaceModal)
  const dispatch = useDispatch()
  const handleCancel = () => dispatch(closeModal())

  return (
    <>
      <Modal
        title=''
        centered
        open={INTERFACE?.isOpen}
        onCancel={handleCancel}
        footer={false}
        className='player_details_modal'
      >
        <PlayerInterfacePopup closeModal={handleCancel} />
      </Modal>
    </>
  )
}

export default PlayerDetailsModal
